/*
 * ByLamari: Reihen des übertragenen Hydrogen-Neubaus (Theme-Kopie B, 25.10.2026).
 *  - Karussell-Pfeile (components/startseite/Karussell.tsx)
 *  - Laufband anhalten (components/startseite/Laufband.tsx, WCAG 2.2.2)
 *  - „Bestseller Kombis“: Karten aus den Daten füllen, Farbe wählen, „Alle 3 in den Warenkorb“
 *    (components/Stacks.tsx, components/kombi/useKombiWarenkorb.ts)
 */
(function () {
  var BL = (window.BL = window.BL || {});

  document.addEventListener('click', function (e) {
    var t = e.target;
    var pfeil = t.closest && t.closest('[data-bl-blaettern]');
    if (pfeil) {
      var liste = pfeil.closest('.bl-karussell').querySelector('.bl-karussell__liste');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      liste.scrollBy({ left: parseInt(pfeil.getAttribute('data-bl-blaettern'), 10) * liste.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    var pause = t.closest && t.closest('[data-bl-laufband-pause]');
    if (pause) {
      var band = pause.closest('.bl-laufband');
      var an = !band.classList.contains('is-pausiert');
      band.classList.toggle('is-pausiert', an);
      pause.setAttribute('aria-pressed', String(an));
      pause.setAttribute('aria-label', an ? 'Laufband abspielen' : 'Laufband anhalten');
      pause.querySelector('[data-bl-pause]').hidden = an;
      pause.querySelector('[data-bl-spielen]').hidden = !an;
    }
  });

  /* ── Bestseller Kombis ─────────────────────────────────────────────── */
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function kurz(t) { return t.replace(/\s+Ring$/i, ''); }
  function bild(url, px) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + px + '&height=' + px + '&crop=center'; }
  // 1x/2x/3x für Bilder fester Größe (lib/shopify-image.ts quadratSrcSet, Schärfe 3.11.2026)
  function dichten(url, css) { return [1, 2, 3].map(function (d) { return bild(url, css * d) + ' ' + d + 'x'; }).join(', '); }
  function tupfer(name) {
    var k = /gold und silber/i.test(name) ? 'is-mix' : /silber/i.test(name) ? 'is-silber' : 'is-gold';
    return '<span class="bl-stack__tupfer ' + k + '" aria-hidden="true"></span>';
  }
  function farbIndex(fassungen, wunsch) {
    if (!wunsch) return 0;
    var w = wunsch.toLowerCase();
    for (var i = 0; i < fassungen.length; i++) {
      var n = fassungen[i].n.toLowerCase();
      if (w === 'bicolor' ? /bicolor|gemischt|und/.test(n) : n === w) return i;
    }
    return 0;
  }
  function zeige(art, i) {
    var f = art._blF[i] || art._blF[0];
    art._blI = i;
    var id = art.getAttribute('data-bl-stack-id');
    var name = art.getAttribute('data-bl-stack-name');
    var ziel = '/pages/kombis/' + id + (i === 0 ? '' : '?farbe=' + encodeURIComponent(f.s));
    art.querySelectorAll('[data-bl-stack-ziel]').forEach(function (a) { a.href = ziel; });
    var b = art.querySelector('[data-bl-stack-bild]');
    b.setAttribute('aria-label', name + ': ' + f.r.map(function (r) { return r.t + ' in ' + r.f; }).join(', '));
    b.innerHTML = f.r.map(function (r, j) {
      var px = j === 0 ? 560 : 320;
      return '<span class="bl-stack__feld' + (j === 0 ? ' is-haupt' : '') + '"><img src="' + esc(bild(r.b, px)) + '" srcset="' + esc(dichten(r.b, j === 0 ? 320 : 180)) + '" alt="" width="' + px + '" height="' + px + '" loading="lazy" decoding="async" draggable="false"></span>';
    }).join('');
    art.querySelector('[data-bl-stack-ringe]').innerHTML = f.r.map(function (r, j) {
      return '<span>' + (j > 0 ? '<span aria-hidden="true"> · </span>' : '') + '<a class="bl-stack__ring-link" aria-label="' + esc(r.t + ' in ' + r.f + ' ansehen') + '" href="' + esc(r.z) + '">' + esc(kurz(r.t)) + '</a></span>';
    }).join('');
    art.querySelector('[data-bl-stack-einzeln]').textContent = 'Einzeln ' + f.e;
    art.querySelector('[data-bl-stack-zahlst]').textContent = 'Du zahlst ' + f.z;
    var farben = art.querySelector('[data-bl-stack-farben]');
    if (farben) {
      farben.innerHTML = art._blF.map(function (x, j) {
        return '<button type="button" role="radio" aria-checked="' + (j === i) + '" class="bl-stack__farbe" data-bl-stack-wahl="' + j + '">' + tupfer(x.n) + esc(x.n) + '</button>';
      }).join('');
    }
    var fest = art.querySelector('[data-bl-stack-fest]');
    if (fest) fest.innerHTML = tupfer(f.n) + esc(/gold und silber/i.test(f.n) ? f.n + ' gemischt' : 'In ' + f.n);
    art.querySelector('[data-bl-stack-sr]').textContent = f.n + ', du zahlst ' + f.z;
  }
  function stacksFuellen(wurzel) {
    (wurzel || document).querySelectorAll('[data-bl-stack]').forEach(function (art) {
      if (art._blF) return;
      try { art._blF = JSON.parse(art.getAttribute('data-bl-stack')); } catch (e) { return; }
      zeige(art, parseInt(art.getAttribute('data-bl-start'), 10) || 0);
    });
  }
  BL.stacksFuellen = stacksFuellen;
  /* Oben gewählte Farbe (Kategorie Ringe): Karten folgen, passende Kombis zuerst */
  BL.stacksFarbe = function (wunsch) {
    document.querySelectorAll('[data-bl-stacks]').forEach(function (sek) {
      var liste = sek.querySelector('.bl-karussell__liste');
      var karten = Array.prototype.slice.call(liste.children);
      karten.forEach(function (li, nr) { if (li._blNr == null) li._blNr = nr; });
      karten.forEach(function (li) {
        var art = li.querySelector('[data-bl-stack]');
        if (art && art._blF) zeige(art, farbIndex(art._blF, wunsch));
      });
      function hat(li) {
        var art = li.querySelector('[data-bl-stack]');
        if (!art || !art._blF || !wunsch) return 1;
        var w = wunsch.toLowerCase(), n = art._blF[art._blI].n.toLowerCase();
        return (w === 'bicolor' ? /bicolor|gemischt|und/.test(n) : n === w) ? 1 : 0;
      }
      karten.sort(function (a, b) { return (hat(b) - hat(a)) || (a._blNr - b._blNr); }).forEach(function (li) { liste.appendChild(li); });
    });
  };
  document.addEventListener('click', function (e) {
    var wahl = e.target.closest && e.target.closest('[data-bl-stack-wahl]');
    if (wahl) {
      zeige(wahl.closest('[data-bl-stack]'), parseInt(wahl.getAttribute('data-bl-stack-wahl'), 10));
      return;
    }
    var knopf = e.target.closest && e.target.closest('[data-bl-stack-knopf]');
    if (!knopf || knopf.disabled) return;
    var art = knopf.closest('[data-bl-stack]');
    var f = art._blF[art._blI];
    var fehler = art.querySelector('[data-bl-stack-fehler]');
    var meldung = art.querySelector('[data-bl-stack-meldung]');
    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');
    fehler.hidden = true;
    meldung.textContent = '';
    BL.inDenWarenkorb(f.r.map(function (r) { return { id: r.v, quantity: 1 }; }))
      .then(function () { meldung.textContent = art.getAttribute('data-bl-stack-name') + ': Alle 3 Ringe liegen im Warenkorb.'; })
      .catch(function (err) {
        if (BL.schliesse) BL.schliesse('cart-drawer');
        fehler.textContent = (err && err.message) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
        fehler.hidden = false;
      })
      .finally(function () { knopf.disabled = false; knopf.removeAttribute('aria-busy'); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { stacksFuellen(); });
  else stacksFuellen();
})();